// Константы приложения

// Валюта
export const CURRENCY = {
  symbol: '₸',
  name: 'тенге',
  code: 'KZT'
};

// Координаты по умолчанию (Астана)
export const DEFAULT_COORDINATES = {
  latitude: 51.1694,
  longitude: 71.4491,
  city: 'Астана'
};

/**
 * Предел вложенности разделов каталога, считая корень.
 *
 * Дублирует `catalog.max_category_depth` на бэке: кабинет прячет по нему
 * кнопку «подраздел», а последнее слово всё равно за сервером — он ответит
 * 422, если значения разойдутся.
 */
export const MAX_CATEGORY_DEPTH = 4;
